import { AssetRequestCreateInput } from '@atom/types/assetRequest';
import { Client } from '@atom/utilities/featureToggleUtilities';
import { assetRequestClient } from '@atom/utilities/tenantFeatureUtilities';

import { getADOTCreateDisabled } from './adotCreate/adotCreateUtilities';
import { getARDOTCreateDisabled } from './ardotCreate/ardotCreateUtilities';
import {
  getSDDOTCreateDisabled,
  TotalRemainingState,
} from './sddotCreate/sddotCreateUtilities';

export type CreateDisabledContext = {
  // TODO: [AM-16707]: Temp code until BE solution is built
  totals: TotalRemainingState;
  transferToggle: boolean;
};

// Dispatches create-form validation to the current client.
export const getCreateDisabled = (
  createInputs: AssetRequestCreateInput,
  { totals, transferToggle }: CreateDisabledContext,
): boolean => {
  switch (assetRequestClient) {
    case Client.SDDOT:
      return getSDDOTCreateDisabled(createInputs, totals);
    case Client.ARDOT:
      return getARDOTCreateDisabled(createInputs, transferToggle);
    case Client.ADOT:
      return getADOTCreateDisabled(createInputs, totals);
    default:
      return false;
  }
};
